import { Box } from "@mui/material";

import EmptyHomeImg from "@app/analytics/assets/home/empty_home.png";
import ROUTES from "@app/common/routes";

import Button from "@rui/Button";
import {
  EmptyStateContainer,
  EmptyStateTitle,
  EmptyStateSubtext,
} from "@rui/EmptyStateContainer";
import { Link } from "@rui/Link";
import Stack from "@rui/Stack";

const NoNotifications = () => {
  return (
    <Stack
      variant="center"
      height="100%"
      width="100%"
      flexGrow={1}
      minHeight="400px"
      sx={{ backgroundColor: "transparent.white.60", borderRadius: "8px" }}
    >
      <EmptyStateContainer
        border={0}
        variant="center"
        flex={1}
        spacing={2}
        height="100%"
        backgroundColor="transparent"
        color="shades.neutral.600"
      >
        <Box component="img" src={EmptyHomeImg} width="150px" />
        <EmptyStateTitle>No notifications</EmptyStateTitle>
        <EmptyStateSubtext>
          It’s pretty quiet in here. Add Read to a few meetings and check back
          to see your updates.
        </EmptyStateSubtext>
        <Link to={ROUTES.CALENDAR_UPCOMING}>
          <Button>Add Read to your meetings</Button>
        </Link>
      </EmptyStateContainer>
    </Stack>
  );
};

export default NoNotifications;
